export default __webpack_public_path__ + "static/media/photo5.0cec68f2.jpg";